// config.js
// Значения задаются через переменные окружения при сборке (react-scripts build).
// Create React App встраивает переменные REACT_APP_* в итоговый бандл — они видны
// всем посетителям сайта, поэтому НЕ храните здесь секреты (пароли, приватные ключи).
// Шаблон переменных — в файле .env.example.

const config = {
  apiUrl: (process.env.REACT_APP_API_URL || '').replace(/\/+$/, ''),
  nameCargo: process.env.REACT_APP_NAME_CARGO || '291cargo',
  vapidPublicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY || '',
};

if (!config.apiUrl) {
  // eslint-disable-next-line no-console
  console.error('[config] Не задан REACT_APP_API_URL — запросы к API работать не будут. См. .env.example');
}

export default config;
